// Compliance (TRAI) — the TCCCPR Third Amendment screens.
//
// EVERYTHING HERE IS SHADOW. The server records and reports; it refuses no call, message or
// campaign because of any of it. The banner says so on every tab, because a red "would suspend"
// without that sentence next to it reads as an outage.
import React from 'react';
import { NavLink } from 'react-router-dom';
import { ShieldAlert, Info } from 'lucide-react';
import CategoriesTab from './CategoriesTab';
import NumbersTab from './NumbersTab';
import ConsentTab from './ConsentTab';
import ComplaintsTab from './ComplaintsTab';

export type TraiTab = 'categories' | 'numbers' | 'consent' | 'complaints';

const TABS: ReadonlyArray<readonly [TraiTab, string]> = [
  ['categories', 'Call category'],
  ['numbers', 'Number declarations'],
  ['consent', 'Consent'],
  ['complaints', 'Complaints'],
];

const TraiCompliance: React.FC<{ tab: TraiTab }> = ({ tab }) => (
  <div className="p-6 space-y-5 max-w-6xl">
    <header className="space-y-1">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
        <ShieldAlert className="w-6 h-6" /> Compliance (TRAI)
      </h1>
      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
        TCCCPR Third Amendment: A2P declarations, call categories, consent and complaint thresholds.
      </p>
    </header>

    <div className="rounded-xl border px-4 py-3 text-sm flex items-start gap-2"
         style={{ background: 'var(--info-bg)', color: 'var(--info-text)', borderColor: 'transparent' }}>
      <Info className="w-4 h-4 mt-0.5 shrink-0" />
      <span>
        Shadow mode: nothing on these pages blocks a call. Categories, declarations and consent are recorded and
        reported; complaint thresholds are computed and alerts stored. Switching anything to enforcement is a
        platform decision made later.
      </span>
    </div>

    <nav className="flex gap-1 border-b border-gray-200 dark:border-gray-700">
      {TABS.map(([id, label]) => (
        <NavLink key={id} to={`/compliance/${id}`}
                 className={() => `px-3 py-2 text-sm -mb-px border-b-2 ${tab === id
                   ? 'border-current font-medium' : 'border-transparent'}`}
                 style={tab === id ? undefined : { color: 'var(--text-muted)' }}>
          {label}
        </NavLink>
      ))}
    </nav>

    {tab === 'categories' && <CategoriesTab />}
    {tab === 'numbers' && <NumbersTab />}
    {tab === 'consent' && <ConsentTab />}
    {tab === 'complaints' && <ComplaintsTab />}
  </div>
);

export default TraiCompliance;
